import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ZtTextAreaConfig } from './zt-textarea.model';

@Component({
    selector: 'zt-textarea',
    templateUrl: 'zt-textarea.component.html',
    styleUrls: ['zt-textarea.component.scss'],
})
export class ZtTextAreaComponent {
    @Input() value: string = '';
    @Input() config: ZtTextAreaConfig | undefined;
    @Input() control!: FormControl;

    @Output() onChange = new EventEmitter<string>();

    onChangeListener(newValue: string) {
        this.onChange.emit(newValue);
    }
}
